import { Toaster } from "components/notification/Toaster";
import { useDispatch } from "react-redux";
import usePromiseInstance_authorization from "./config";
import { func_serviceHandling, func_validation, isNotNullUndefined, isStringNotEmpty } from "functions";
import moment from "moment";
import { 
    setLicenseComId,
    setLicensePackageName,
    getPackageList_request,
    getPackageList_success,
    getPackageList_failure,
    getLicensePackage_request,
    getLicensePackage_success,
    getLicensePackage_failure,
    switchTrial_request,
    switchTrial_success,
    switchTrial_failure,
    updateDeleteDate_request,
    updateDeleteDate_success,
    updateDeleteDate_failure,
    generateLicense_request,
    generateLicense_success,
    generateLicense_failure,
    extendDate_request,
    extendDate_success,
    extendDate_failure,
    getLicenseReport_request,
    getLicenseReport_success,
    getLicenseReport_failure,
    exportLicenseReport_request,
	exportLicenseReport_success,
	exportLicenseReport_failure
 } from "../slices/mobileLicenseKey.slices";
 import { useCustomSelector } from "hooks";

export default function useMobileLicenseKey() {
    let { licensePackageComId, licensePackagePackageName } = useCustomSelector("mobileLicenseKey");

    const dispatch = useDispatch();
    const request = usePromiseInstance_authorization();

    function setLicensePackageComId(comId) {
        dispatch(setLicenseComId(comId));
    }

    function setLicensePackagePackageName(packageName) {
        dispatch(setLicensePackageName(packageName));
    }

    function getPackageList() {

        dispatch(getPackageList_request());

        request(getPackageList_request, (axios) => {    
            axios.get('/ComInfo/GetPackageList')
                .then((response) => {
                    dispatch(getPackageList_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load Packages(s)";
					Toaster({ type: "error", msg });

                    dispatch(getPackageList_failure(msg));
                })
        })
    }

    function getLicensePackage(pageNo, pageSize, sort, filterOptions = {}) {
        let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let filterOptions__validated = isNotNullUndefined(filterOptions)? filterOptions:{};

        let { isdeleted, isTrial, isTrialExpired, ...otherFilterOptions } = filterOptions__validated

		let paramObj = {
			offset,
			limit: pageSize,
			...otherFilterOptions,
            ComId: licensePackageComId,
            ...(isNotNullUndefined(isdeleted) && isStringNotEmpty(isdeleted))? {
                isdeleted: (isdeleted === "Yes")? true:false
            }:{},
            ...(isNotNullUndefined(isTrial) && isStringNotEmpty(isTrial))? {
                isTrial: (isTrial === "Yes")? true:false
            }:{},
            ...(isNotNullUndefined(isTrialExpired) && isStringNotEmpty(isTrialExpired))? {
                isTrialExpired: (isTrialExpired === "Yes")? true:false
            }:{},
		}

        let url = func_serviceHandling.createUrlWithParams('/ComInfo/GetLicensePackageByComId', paramObj)

        dispatch(getLicensePackage_request());

        request(getLicensePackage_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getLicensePackage_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load License Packages(s)";
					Toaster({ type: "error", msg });

                    dispatch(getLicensePackage_failure(msg));
                })
        })
    }

    function switchTrial(comId, licenseKey, trialExpiryDate) {

        let paramObj = {
            comId: comId,
            licenseKey: licenseKey,
            trialExpiredDate: trialExpiryDate
		}

        dispatch(switchTrial_request());

        request(switchTrial_request, (axios) => {    
            axios.put('/ComInfo/SwitchToTrial', paramObj)
                .then((response) => {
                    dispatch(switchTrial_success(response.data));
                    let msg = response?.data;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Switch Trial success" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to switch trial";
					Toaster({ type: "error", msg });

                    dispatch(switchTrial_failure(msg));
                })
        })
    }

    function updateDeleteDate(comId, licenseKey, deleteDate) {

        let url = func_serviceHandling.createUrlWithParams('/ComInfo/UpdateLicenseKeyDeleteDate', { newDeleteDate: deleteDate })

        let paramObj = {
            comId: comId,
            licenseKey: licenseKey
		}

        dispatch(updateDeleteDate_request());

        request(updateDeleteDate_request, (axios) => {    
            axios.put(url, paramObj)
                .then((response) => {
                    dispatch(updateDeleteDate_success(response.data));
                    let msg = response?.data;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Update delete date success" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to update delete date";
					Toaster({ type: "error", msg });

                    dispatch(updateDeleteDate_failure(msg));
                })
        })
    }

    function generateLicense(comId, packageName, trialExpiryDate) {

        let paramObj = {
            comId: comId,
            packageName: packageName,
            trialExpiryDate: trialExpiryDate
		}

        let url = func_serviceHandling.createUrlWithParams('/ComInfo/GenerateLicenseKeyTrial', paramObj)

        dispatch(generateLicense_request());

        request(generateLicense_request, (axios) => {    
            axios.post(url)
                .then((response) => {
                    dispatch(generateLicense_success(response.data));
                    let msg = response?.data;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Generate license success" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to generate license";
					Toaster({ type: "error", msg });

                    dispatch(generateLicense_failure(msg));
                })
        })
    }

    function extendDate(comId, licenseKey, trialExpiryDate) {

        let paramObj = {
            comId: comId,
            licenseKey: licenseKey,
            trialExpiredDate: trialExpiryDate
		}

        dispatch(extendDate_request());

        request(extendDate_request, (axios) => {    
            axios.put('/ComInfo/ExtendTrialLicenseKeyExpiryDate', paramObj)
                .then((response) => {
                    dispatch(extendDate_success(response.data));
                    let msg = response?.data;
                    Toaster({ type: "success", msg: func_validation.isNotNullUndefined(msg)? msg:"Extend Date success" });
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to extend Date";
					Toaster({ type: "error", msg });

                    dispatch(extendDate_failure(msg));
                })
        })
    }

    function getLicenseReport(pageNo, pageSize, sort, filterOptions = {}) {
        let isOffsetValid = func_validation.isNumberValid(pageNo) && func_validation.isNumberValid(pageSize);
		let offset = isOffsetValid? pageNo * pageSize:0;

		let filterOptions__validated = isNotNullUndefined(filterOptions)? filterOptions:{};

        let { isTrial, deletedDate, isTrialExpired, licenseSource, ...otherFilterOptions } = filterOptions__validated

		let paramObj = {
			offset,
			limit: pageSize,
			...otherFilterOptions,
            packageName: licensePackagePackageName,
            ...(isNotNullUndefined(isTrial) && isStringNotEmpty(isTrial))? {
                isTrial: (isTrial === "Yes")? true:false
            }:{},
            ...(isNotNullUndefined(deletedDate) && isStringNotEmpty(deletedDate))? {
                deletedDate: moment(deletedDate).format("YYYY-MM-DD")
            }:{},
            ...(isNotNullUndefined(isTrialExpired) && isStringNotEmpty(isTrialExpired))? {
                isTrialExpired: (isTrialExpired === "Yes")? true:false
            }:{},
            ...(isNotNullUndefined(licenseSource) && isStringNotEmpty(licenseSource))? {
                licenseSource: (licenseSource === "Maxis")? true:false
            }:{},
		}

        let url = func_serviceHandling.createUrlWithParams('/Report/GetMobileLicenseReport', paramObj)

        dispatch(getLicenseReport_request());

        request(getLicenseReport_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(getLicenseReport_success(response));
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to load License Packages(s)";
					Toaster({ type: "error", msg });

                    dispatch(getLicenseReport_failure(msg));
                })
        })
    }

    function exportLicenseReport(licensePackagePackageName, filterOptions = {}) {

        let filterOptions__validated = isNotNullUndefined(filterOptions)? filterOptions:{};

        let { isTrial, deletedDate, isTrialExpired, licenseSource, ...otherFilterOptions } = filterOptions__validated

		let paramObj = {
            ...otherFilterOptions,
            packageName: licensePackagePackageName,
            ...(isNotNullUndefined(isTrial) && isStringNotEmpty(isTrial))? {
                isTrial: (isTrial === "Yes")? true:false
            }:{},
            ...(isNotNullUndefined(deletedDate) && isStringNotEmpty(deletedDate))? {
                deletedDate: moment(deletedDate).format("YYYY-MM-DD")
            }:{},
            ...(isNotNullUndefined(isTrialExpired) && isStringNotEmpty(isTrialExpired))? {
                isTrialExpired: (isTrialExpired === "Yes")? true:false
            }:{},
            ...(isNotNullUndefined(licenseSource) && isStringNotEmpty(licenseSource))? {
                licenseSource: (licenseSource === "Maxis")? true:false
            }:{},
		}

        let url = func_serviceHandling.createUrlWithParams('/report/GetMobileLicenseReport/Export', paramObj)

        dispatch(exportLicenseReport_request());

        request(exportLicenseReport_request, (axios) => {    
            axios.get(url)
                .then((response) => {
                    dispatch(exportLicenseReport_success(response));
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${licensePackagePackageName.split(" ").join("_")}.csv`);
                    document.body.appendChild(link);
                    link.click();
        
                    Toaster({
                        type: "success",
                        msg: "Successfully export product license key report"
                    })
                })
                .catch((error) => {
                    let msg = error?.response?.data?.exceptionMessage? error.response.data.exceptionMessage: "Failed to export License Packages(s)";
					Toaster({ type: "error", msg });

                    dispatch(exportLicenseReport_failure(msg));
                })
        })
    }

    return {
        setLicensePackageComId,
        setLicensePackagePackageName,
        getPackageList,
        getLicensePackage,
        switchTrial,
        updateDeleteDate,
        generateLicense,
        extendDate,
        getLicenseReport,
        exportLicenseReport
    }
}